import { useCallback, useState } from 'react';

/**
 * Hook that provides a boolean state with convenient setter functions
 * @param defaultValue The initial boolean value (defaults to false)
 * @returns A tuple containing [value, setTrue, setFalse]
 */
export const useBooleanState = (
  defaultValue: boolean = false
): [boolean, () => void, () => void] => {
  const [value, setValue] = useState<boolean>(defaultValue);

  const setTrue = useCallback((): void => {
    setValue(true);
  }, []);

  const setFalse = useCallback((): void => {
    setValue(false);
  }, []);

  return [value, setTrue, setFalse];
};
